// EntityLabel.tsx — One name label for every selectable body (star, planet, moon,
// gate). drei <Html> anchors it at the body centre with NO world-space offset and NO
// distance scaling, and CSS (.entity-label) lifts the text directly ABOVE the anchor
// in screen space — so the label sits over the body whatever way the camera is turned
// — and pins it to a constant size. Pointer-events are off so it can't steal a click
// from the body underneath.
import { Html } from '@react-three/drei';

interface Props {
  text: string;
  /** Optional secondary line (e.g. a star's spectral class, a gate's distance). */
  sub?: string;
  /** Brighten (hovered / selected) over the dim default. */
  lit?: boolean;
}

export function EntityLabel({ text, sub, lit = false }: Props) {
  return (
    <Html zIndexRange={[19, 0]} style={{ pointerEvents: 'none' }}>
      <div className={lit ? 'entity-label lit' : 'entity-label'}>
        {text}
        {sub ? <span>{sub}</span> : null}
      </div>
    </Html>
  );
}
